module.exports = __webpack_public_path__ + "img/paas_wrapbg4.0cb7b3d5.png";